import GuestWelcome from "./GuestWelcome";

export default GuestWelcome;